import DocMedsConsultationCompleteWithoutMeds from ".";

export default function DocMedsConsultationCompleteWithoutMedsExamples() {
  return <DocMedsConsultationCompleteWithoutMeds />;
}
